var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 21.6666H31.6668V18.3333H23.3335V21.6666ZM23.3335 16.6666H31.6668V13.3333H23.3335V16.6666ZM8.3335 26.6666H21.6668V25.75C21.6668 24.5 21.0557 23.5072 19.8335 22.7716C18.6113 22.0361 17.0002 21.6677 15.0002 21.6666C13.0002 21.6655 11.3891 22.0338 10.1668 22.7716C8.94461 23.5094 8.3335 24.5022 8.3335 25.75V26.6666ZM15.0002 20C15.9168 20 16.7018 19.6738 17.3552 19.0216C18.0085 18.3694 18.3346 17.5844 18.3335 16.6666C18.3324 15.7488 18.0063 14.9644 17.3552 14.3133C16.7041 13.6622 15.9191 13.3355 15.0002 13.3333C14.0813 13.3311 13.2968 13.6577 12.6468 14.3133C11.9968 14.9688 11.6702 15.7533 11.6668 16.6666C11.6635 17.58 11.9902 18.365 12.6468 19.0216C13.3035 19.6783 14.0879 20.0044 15.0002 20ZM6.66683 33.3333C5.75016 33.3333 4.96572 33.0072 4.3135 32.355C3.66127 31.7027 3.33461 30.9177 3.3335 30V9.99996C3.3335 9.08329 3.66016 8.29885 4.3135 7.64663C4.96683 6.9944 5.75127 6.66774 6.66683 6.66663H33.3335C34.2502 6.66663 35.0352 6.99329 35.6885 7.64663C36.3418 8.29996 36.6679 9.0844 36.6668 9.99996V30C36.6668 30.9166 36.3407 31.7016 35.6885 32.355C35.0363 33.0083 34.2513 33.3344 33.3335 33.3333H6.66683ZM6.66683 30H33.3335V9.99996H6.66683V30Z",
    fill: "#F6764E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardViewIcon);
export default __webpack_public_path__ + "static/media/cardViewIcon.37895243293f85a121538744701600c3.svg";
export { ForwardRef as ReactComponent };